import React, { useState } from "react";
import {
  Box,
  InputBase,
  makeStyles,
  Typography,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import clsx from "clsx";

import { withStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
  },
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 3,
    width: "2.4rem",
    height: "2.4rem",
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "transparent",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#1ED059",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: "2.4rem",
      height: "2.4rem",
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#1ED059",
    },
  },
}));

const CustomCheckbox = ({ label, checked, handleChange, disable }) => {
  const classes = useStyles();

  const GreenCheckbox = withStyles({
    root: {
      color: green[400],
      "&$checked": {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);
  return (
    <Box className={classes.inputWithLabelContainer}>
      <FormControlLabel
        control={
          <GreenCheckbox
            disabled={disable}
            checked={checked}
            onChange={handleChange}
            name="checkedG"
            checkedIcon={
              <span className={clsx(classes.icon, classes.checkedIcon)} />
            }
            icon={<span className={classes.icon} />}
          />
        }
        label={label}
        classes={{ label: classes.label }}
      />
    </Box>
  );
};

export default CustomCheckbox;
